var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcAddPlace(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.182,
    height: 11.097,
    viewBox: "0 0 12.182 11.097",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_508",
    "data-name": "Group 508",
    transform: "translate(-1908.564 -1853.911)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_201",
    "data-name": "Group 201"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_514",
    "data-name": "Path 514",
    d: "M1910.642,1861.791a.335.335,0,0,1,.268-.134h1.675a.335.335,0,1,1,0,.67h-1.508l-1.508,2.011h8.713l-1.508-2.011h-1.508a.335.335,0,0,1,0-.67h1.675a.335.335,0,0,1,.268.134l2.011,2.681a.335.335,0,0,1-.067.469.339.339,0,0,1-.2.067H1908.9a.335.335,0,0,1-.268-.536Z",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_515",
    "data-name": "Path 515",
    d: "M1913.925,1854.956a2.01,2.01,0,1,0,2.011,2.01A2.01,2.01,0,0,0,1913.925,1854.956Zm-2.68,2.01a2.68,2.68,0,1,1,3.016,2.66v3.707a.336.336,0,0,1-.671,0v-3.706a2.68,2.68,0,0,1-2.345-2.662Z",
    fill: "#fff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_121",
    "data-name": "Line 121",
    x2: 2.74,
    transform: "translate(1917.63 1855.656)",
    fill: "none",
    stroke: "#fefefe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_122",
    "data-name": "Line 122",
    y2: 2.74,
    transform: "translate(1919.001 1854.286)",
    fill: "none",
    stroke: "#fefefe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAddPlace);
export default __webpack_public_path__ + "static/media/ic-add-place.cd292fa106a64964bf54e6725e3e2ed4.svg";
export { ForwardRef as ReactComponent };